import { ReactComponent as AmcCompetitionDesktop } from '../../images/amc_competition_desktop.svg';
import { ReactComponent as AmcCompetitionMobile } from '../../images/amc_competition_mobile.svg';
import YoutubeColumns from './YoutubeColumns';
import { WALKTHROUGH_VIDEOS } from './walkthroughVideos';

export default function LandingPage() {
  return (
    <div className="landing">
      <section className="landing-hero" sx={{ mb: 0}}>
        <AmcCompetitionDesktop className="landing-banner landing-banner--desktop" aria-label="AMC competition" role="img" />
        <AmcCompetitionMobile className="landing-banner landing-banner--mobile" aria-label="AMC competition" role="img" />
      </section>
      <section id="walkthrough" className="landing-videos" sx={{ mt: 0}}>
        <div className="landing-videos__inner">
          <h2 className="landing-videos__title">Demos</h2>
          <YoutubeColumns videos={WALKTHROUGH_VIDEOS} />
        </div>
      </section>
    </div>
  );
}
